export default __webpack_public_path__ + "static/media/logo-digital-india.a8cd842a.png";